import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styles from './Input.module.css';
export const Input = forwardRef(({ label, error, icon, className, ...props }, ref) => {
    return (_jsxs("div", { children: [_jsxs("div", { className: styles.formControl, children: [icon && _jsx("div", { className: styles.iconBox, children: icon }), _jsx("input", { ref: ref, className: styles.input, ...props })] }), error && _jsx("span", { className: styles.error, children: error })] }));
});
Input.displayName = 'Input';
